import { render } from "./ConfirmForgotPassword.vue?vue&type=template&id=5e24f4e0"
import script from "./ConfirmForgotPassword.vue?vue&type=script&lang=js"
export * from "./ConfirmForgotPassword.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__